import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import AboutUs from "./components/AboutUs";
import Strengths from "./components/Strengths";
import Infrastructure from "./components/Infrastructure";
import QualityManagement from "./components/QualityManagement";
import ContactUs from "./components/ContactUs";
import EnquiryForm from "./components/EnquiryForm";
import Footer from "./components/Footer";
import AdminDashboard from "./components/AdminDashboard";

const HomePage = () => {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <AboutUs />
        <Strengths />
        <Infrastructure />
        <QualityManagement />
        <ContactUs />
        <EnquiryForm />
      </main>
      <Footer />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
